(function ($, Drupal, drupalSettings) {
    'use strict';

    var initialized = false;

    // define some vars
    let g_$carouselWrapper = null,
        g_Carousel = null,
        g_$slider,
        g_$sliderLegend = $('<div class="slider-legend"></div>'),
        g_isFullScreen = false;


    Drupal.behaviors.sliderEcoparc = {
        attach: function (context, setting) {
            if (!initialized) {
                initialized = true;
                Drupal.behaviors.sliderEcoparc.init();
            }
        },
        init: function () {

            g_$carouselWrapper = $('.carousel-wrapper');
            this.flickityCarousel();
            // slider of logos
            const $slider = $('.slider');
            if ($slider.length) {
                $slider.flickity({
                    cellAlign: 'center',
                    groupCells: true,
                    prevNextButtons: true,
                    autoPlay: 4000,
                    wrapAround: true,
                    pageDots: false
                })
            }
            // images slider
            const $sliderImages = $('.slider-images');
            if ($sliderImages.length) {
                g_$slider = $sliderImages.flickity({
                    imagesLoaded: true,
                    cellAlign: 'center',
                    groupCells: true,
                    prevNextButtons: false,
                    autoPlay: false,
                    wrapAround: true,
                    pageDots: true,
                    lazyLoad: 2,
                    fullscreen: true,
                });
                const dotWidth = 100 / g_$slider.data('flickity').slides.length;
                $('.flickity-page-dots .dot').width(dotWidth + '%');

                const flkty = g_$slider.data('flickity');

                g_$slider.on('fullscreenChange.flickity', function (event, isFullscreen) {
                    g_isFullScreen = isFullscreen;
                    if (isFullscreen) {
                        $('header').hide();
                        $('li', $sliderImages).each(function (cell) {
                            var $img = $(this).find('img');
                            $img.attr('src', $img.data('large-image'));
                        });
                        g_$sliderLegend.appendTo($('.slider-images')).text($('img', flkty.selectedElement).attr('title'));
                    } else {
                        $('header').show();
                        g_$sliderLegend.remove();
                        $('li', $sliderImages).each(function (cell) {
                            var $img = $(this).find('img');
                            $img.attr('src', $img.data('small-image'));
                        });
                    }
                });

                g_$slider.on('change.flickity', function(event, index) {
                  if (g_isFullScreen) {
                    g_$sliderLegend.appendTo($('.slider-images')).text($('img', flkty.selectedElement).attr('title'));
                  }
                });
            }

            window.dispatchEvent(new Event('resize'));
        },

        setCaption: function (caption) {
            g_$sliderLegend.text(caption);
        },

        flickityCarousel: function () {
            if (g_$carouselWrapper.length) {
                g_Carousel = g_$carouselWrapper.flickity({
                    cellAlign: 'center',
                    prevNextButtons: false,
                    autoPlay: 4000,
                    wrapAround: true,
                    pageDots: true
                });
            }
        }

    };
})(jQuery, Drupal, drupalSettings);




















